import store from '@/store'

class EditionJudge {
    get isDEV() {
        return process.env.VUE_APP_ENV === 'development'
    }

    get isUAT() {
        return process.env.VUE_APP_ENV === 'uat'
    }

    get isPRO() {
        return process.env.VUE_APP_ENV === 'production'
    }

    get isSunmi() {
        const shopInfo = (store.state as any).shop.shopInfo
        // return shopInfo.can_renewal && shopInfo.renewal_times
        return shopInfo.from_sunmi
    }

    get isRealZhuanYe() {  // 因为试用期间使用的就是标准版，但是有时候确实需要这个字段来判断是不是购买过标准版
        return !this.isShiYong && this.isZhuanYe
    }

    get isShiYong() {
        return store.getters['shop/isShiYong']
    }

    get isBiaoZhun() {
        return store.getters['shop/isBiaoZhun']
    }

    get isZhuanYe() {
        return store.getters['shop/isZhuanye']
    }

    get isQiJian() {
        return store.getters['shop/isQijian']
    }

    get getShopVersion() {
        return (store.state as any).shop.shopInfo.shop_version
    }

    get remainDay() {
        return (store.state as any).shop.shopInfo.remain_days
    }
}

export const editionJudge = new EditionJudge()

console.log('editionJudge', editionJudge)
